import { render, staticRenderFns } from "./RadioButtonsGroup.vue?vue&type=template&id=a8b00a88&"
import script from "./RadioButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./RadioButtonsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports